import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GovJobsPortal from './GovJobsPortal';

function App() {
  return (
    <Router>
      <GovJobsPortal />
    </Router>
  );
}

export default App;
